@if (organization) {
  <div class="card h-100">
    <div class="card-body pt-1">
      <div class="d-flex flex-column align-items-center">
        <div class="d-flex crop">
          <a [routerLink]="'/organization/' + organization._id">
            <img class="" [src]="organization.image || profilePics.default" alt="">
          </a>
        </div>
      </div>
      <div class="d-flex flex-column">
        <h5 class="card-title mt-1">
          <a [routerLink]="'/organization/' + organization._id">
            {{organization.name}}
          </a>
          @if (isDetailsPage) {
            <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-organization-modal" (click)="toggleEditOrganizationModal('name')">
              <i class="fa fa-pencil"></i> Edit
            </button>
          }
          @if (isDetailsPage) {
            <app-delete-btn-admin (click)="deleteOrganization(organization)"></app-delete-btn-admin>
          }
        </h5>
        @if (organization._politicians?.length) {
          <div class="card-subtitle">
            Stakeholders:
            @for (politician of organization._politicians; track politician; let last = $last) {
              <span>
                <a [routerLink]="'/stakeholder/' + politician._id">{{politician.firstName}} {{politician.lastName}}</a>@if (!last) {
                <span>, </span>
              }
            </span>
          }
        </div>
      }
    </div>
    <div class="mt-2 text-muted small float-end">
      added on {{organization.created_at | date}}
    </div>
  </div>
</div>
}

@if (isEditOrganizationModalVisible) {
  <app-edit-organization-modal [organization]="organization" [field]="field"></app-edit-organization-modal>
}